(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-start-svg.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-start-svg.js');

'use strict';

const ResultStartSvg = () => React.createElement("svg", {
  width: "148",
  height: "325",
  viewBox: "0 0 148 325",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, React.createElement("circle", {
  cx: "105.371",
  cy: "2.53906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "2.53906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "8.25195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "13.965",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "13.965",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "13.965",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "25.3906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "25.3906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "25.3906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "25.3906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "25.3906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "19.6777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "19.6777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "19.6777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "25.3906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "25.3906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "25.3906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "25.3906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "25.3906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "31.1035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "42.5293",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "48.2422",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "53.9551",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "59.668",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "65.3809",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "71.0938",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "76.8066",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "82.5195",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "145.361",
  cy: "88.2323",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "145.361",
  cy: "93.9453",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "145.361",
  cy: "99.6582",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "139.648",
  cy: "105.371",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "111.084",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "116.797",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "122.51",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "128.223",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "133.936",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "139.648",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "145.361",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "151.074",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "156.787",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "162.5",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "168.213",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "173.926",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "179.639",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "185.352",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "191.064",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "196.777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "196.777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "196.777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "196.777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "196.777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "196.777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "196.777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "196.777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "196.777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "196.777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "202.49",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "202.49",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "202.49",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "202.49",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "202.49",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "202.49",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "202.49",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "202.49",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "202.49",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "202.49",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "208.203",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "208.203",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "208.203",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "208.203",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "208.203",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "208.203",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "208.203",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "208.203",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "208.203",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "208.203",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "213.916",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "219.629",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "225.342",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "231.055",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "242.48",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "8.25195",
  cy: "248.193",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "13.9648",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "8.25195",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "2.53906",
  cy: "253.906",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "13.9648",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "8.25195",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "2.53906",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "13.9648",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "8.25195",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "13.9648",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "8.25195",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "13.9648",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "13.9648",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "299.609",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "299.609",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "299.609",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "299.609",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "299.609",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "299.609",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "299.609",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "299.609",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "19.6777",
  cy: "299.609",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "65.3809",
  cy: "305.322",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "305.322",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "305.322",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "305.322",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "305.322",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "305.322",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "305.322",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "305.322",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "59.668",
  cy: "311.035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "53.9551",
  cy: "311.035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "48.2422",
  cy: "311.035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "311.035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "311.035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "311.035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "311.035",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "42.5293",
  cy: "316.748",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "316.748",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "316.748",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "36.8164",
  cy: "322.461",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "31.1035",
  cy: "322.461",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "25.3906",
  cy: "322.461",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "265.332",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "259.619",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "271.045",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "276.758",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "282.471",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "288.184",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "293.896",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "13.9648",
  cy: "236.767",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "93.9453",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "88.2324",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "82.5195",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "76.8066",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "71.0938",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "99.6582",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "133.936",
  cy: "36.8164",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "111.084",
  cy: "19.6777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "105.371",
  cy: "19.6777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "116.797",
  cy: "19.6777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "122.51",
  cy: "19.6777",
  r: "2.53906",
  fill: "#2073E5"
}), React.createElement("circle", {
  cx: "128.223",
  cy: "19.6777",
  r: "2.53906",
  fill: "#2073E5"
}));
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ResultStartSvg
});

 })(window);